import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAuth } from "../../context/authContext";

// 👁️ Import eye icons
import { FaEye, FaEyeSlash } from "react-icons/fa";
const API = process.env.REACT_APP_API_URL;




const SignInForm = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();
  const { syncAuthFromStorage } = useAuth();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.error || "Invalid credentials");
        return;
      }

      const token = data?.token;
      if (!token) {
        toast.error("Login failed: no token");
        return;
      }

      localStorage.setItem("token", token);
      localStorage.setItem("role", "user");

      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
      }

      // Merge guest cart if exists
      const guestCart = JSON.parse(localStorage.getItem("cart") || "[]");
      if (guestCart.length > 0) {
        try {
          await fetch(`${API}/api/cart/merge`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(guestCart),
          });
          localStorage.removeItem("cart");
          toast.success("Guest cart merged successfully!");
        } catch (err) {
          console.error("Cart merge failed:", err);
        }
      }

      syncAuthFromStorage();
      navigate("/");
    } catch (err) {
      console.error(err);
      setErrorMsg("Something went wrong. Try again later.");
    }
  };

  return (
    <div className="form-container sign-in-container">
      <form onSubmit={handleSubmit}>
        <h1>User Sign In</h1>
        {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />

        {/* Password Field with Eye Icon Toggle */}
        <div className="password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
            className="password-input"
          />
          <span
            className="password-toggle-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
          <p 
  style={{ cursor: "pointer", color: "#e53935" }}
  onClick={() => navigate("/forgot-password")}
>
  Forgot Password?
</p>
        </div>

        <button type="submit" className="btn-signin">Sign In</button>
      </form>
    </div>
  );
};

export default SignInForm;